export default "__VITE_ASSET__064af400__"